import React from "react";
import ICONS from "../../constants/icons";
import RatingStars from "../rating-stars/RaitingStars";

import {
  CardCover,
  CardInfo,
  CardInfoDesc,
  CardInfoDownloads,
  CardInfoFooter,
  CardInfoMain,
  CardInfoTitle,
  WholeWrapper,
} from "./components";

const AppCard = ({ icon, name, shortDescription, small, rating, onClick }) => {
  return (
    <WholeWrapper small={small} onClick={onClick}>
      {/* {!small && <CardCategory>{category?.icon}</CardCategory>} */}
      <CardCover img={icon?.publicUrl} />
      <CardInfo small={small}>
        <CardInfoMain>
          <CardInfoTitle>{name}</CardInfoTitle>
          {!small && <CardInfoDesc>{shortDescription}</CardInfoDesc>}
        </CardInfoMain>
        {small && (
          <CardInfoFooter>
            <CardInfoDownloads>
              85k
              <ICONS.Downloads style={{ marginLeft: "0.4rem" }} />
            </CardInfoDownloads>
            <RatingStars rating={rating} />
          </CardInfoFooter>
        )}
      </CardInfo>
    </WholeWrapper>
  );
};

export default AppCard;
